exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-state-container[data-v-43ab4a02] {\n  width: 400px;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 50px 0;\n}\n.empty-state-container .empty-state-media[data-v-43ab4a02] {\n  text-align: center;\n  margin: 50px;\n}\n.empty-state-container .empty-state-media i[data-v-43ab4a02] {\n  font-size: 112px;\n  color: #d9493e;\n}\n.empty-state-container .empty-state-text[data-v-43ab4a02] {\n  text-align: center;\n  font-size: 18px;\n  color: #4b4b4b;\n  margin: 20px 0 40px 0;\n}", ""]);

// exports
